import track, { useTracking } from 'react-tracking';
import SWSLogo from '@assets/images/logo/sws-logo-updated-sm.svg';
import SWSLogoBlack from '@assets/images/logo/sws-logo-black.svg';
import ChevronLeftSolid from '@simplywallst/ui-core/icons/ChevronLeftSolid';
import { RouterLink } from '@redux-first-router-link';
import { ROUTE_DASHBOARD } from '@/constants/routes';
import {
  BackButton,
  SWSLogoWrapper,
  MobileTopbarSearch,
  Wrapper,
  User,
  BrandingWrapper,
  ImageLogo,
  SWSLogoBlackWrapper,
  SWSPoweredBy,
} from './styled';
import Search from '../Search';
import loadable from '@loadable/component';
import { useCompanyShareLink } from '@/hooks/useCompanyShareToken';
import { Grid, Text } from '@simplywallst/ui-core';
import { useHomeRoute } from '@/hooks/useHomeRoute';
import { useTranslation } from '@/hooks/useTranslation';

const UserAccess = loadable(
  () => import('@/components/Nav/MobileTopbar/components/UserAccess')
);

export interface MobileTopbarProps {
  hasSubNav: boolean;
  canGoBack: boolean;
  location: string;
}

const MobileTopbar = ({
  canGoBack,
  hasSubNav,
  location,
}: MobileTopbarProps) => {
  const { trackEvent } = useTracking();
  const { isSharedCompany, logo } = useCompanyShareLink();
  const homeRoute = useHomeRoute();
  const t = useTranslation();

  return isSharedCompany ? (
    <BrandingWrapper hasSubNav={hasSubNav} data-cy-id="branding-wrapper">
      <Grid templateColumns="50% 50%">
        <Grid>
          {typeof logo === 'string' && logo !== '' && (
            <ImageLogo src={logo} alt="company logo" hasSubNav={hasSubNav} />
          )}
        </Grid>
        <Grid alignContent="center" justifyContent="end">
          <SWSPoweredBy>
            <Text typography="tiny" opacity={0.5} color="noirRGBA">
              {t('app.topbar.nav.poweredBy')}
            </Text>
            <SWSLogoBlackWrapper>
              <a
                href="/?view"
                onClick={() =>
                  trackEvent({
                    action: 'click',
                    modifier: 'logo',
                  })
                }
              >
                <SWSLogoBlack />
              </a>
            </SWSLogoBlackWrapper>
          </SWSPoweredBy>
        </Grid>
      </Grid>
    </BrandingWrapper>
  ) : (
    <Wrapper hasSubNav={hasSubNav}>
      <MobileTopbarSearch canGoBack={canGoBack}>
        {canGoBack && (
          <BackButton>
            <button
              onClick={() => {
                window.history.back();
              }}
            >
              <ChevronLeftSolid />
            </button>
          </BackButton>
        )}
        <SWSLogoWrapper canGoBack={canGoBack}>
          <RouterLink
            to={{ type: homeRoute }}
            onClick={() =>
              location !== ROUTE_DASHBOARD &&
              trackEvent({
                action: 'click',
                modifier: 'logo',
              })
            }
          >
            <SWSLogo />
          </RouterLink>
        </SWSLogoWrapper>
        <Search />
        <User>
          <UserAccess />
        </User>
      </MobileTopbarSearch>
    </Wrapper>
  );
};

export default track({
  type: 'track',
  subject: 'mobileTopbarLogo',
})(MobileTopbar) as typeof MobileTopbar;
